import React from 'react';
import { Nav } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import './styles.scss';

export interface NavigationLink {
  route: string;
  label: string;
  onSelect?(): void;
}

interface NavigationProps {
  links: Array<NavigationLink>;
  extra?: React.ReactElement;
}

const MainNavigation: React.FC<NavigationProps> = ({ extra, links }) => {
  const location = useLocation();
  return (
    <div className="main-navigation">
      <Nav as="ul" activeKey={location.pathname}>
        {links.map(({ route, label, onSelect }: NavigationLink, index) => (
          <Nav.Item key={index} as="li" bsPrefix="navigation-item">
            <LinkContainer exact to={route}>
              <Nav.Link bsPrefix="navigation-link" eventKey={route} onSelect={onSelect && onSelect}>
                {label}
              </Nav.Link>
            </LinkContainer>
          </Nav.Item>
        ))}
        {extra && (
          <Nav.Item as="li" bsPrefix="navigation-item">
            {extra}
          </Nav.Item>
        )}
      </Nav>
    </div>
  );
};

export default MainNavigation;
